import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=995dbbb8&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"
import style0 from "./TableList.vue?vue&type=style&index=0&id=995dbbb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995dbbb8",
  null
  
)

export default component.exports